import React, { useRef } from 'react';
var VeltNotificationsPanelContentPeopleListItem = function (props) {
    var data = props.data, listItemTemplate = props.listItemTemplate, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-people-list-item", { ref: ref, data: data ? (typeof data === 'string' ? data : JSON.stringify(data)) : undefined, "list-item-template": listItemTemplate ? (typeof listItemTemplate === 'string' ? listItemTemplate : JSON.stringify(listItemTemplate)) : undefined }, children));
};
export default VeltNotificationsPanelContentPeopleListItem;
